import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MenuItem from './item/item';
import EditMenu from './edit/edit';

import MenuMainComponent from './main.component';


const menuMainModule = angular.module('tinaba.components.menu.main', [
  uiRouter,
  EditMenu.name,
  MenuItem.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('menu.main', {
    url: '/main',
    template: '<menu-main></menu-main>'
  });
})

.component('menuMain', MenuMainComponent);

export default menuMainModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/main.js
 **/